import {
  Tidy
} from '@tableau/catalog-core';
import {
  DatabasesDisplayPlacePageData,
  DatabasesExternalAssetsDisplayGridRowData,
  GraphDataQualityWarning,
  TableauUser,
  TablesDisplayPlacePageData,
  TablesExternalAssetsDisplayGridRowData,
} from '@tableau/catalog-ui-temp';
import _ from 'underscore';

import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';
import { ILuidItem, INamedItem } from '../../../spacesPlatform/models/resourceParts';
import { IUserInfo } from '../../../userManagement/users/models/IUserInfo';

type DataQualityWarningSansAsset = Omit<GraphDataQualityWarning, 'asset'>;

export type GraphDatabase = DatabasesExternalAssetsDisplayGridRowData | DatabasesDisplayPlacePageData;
export type GraphTable = TablesExternalAssetsDisplayGridRowData | TablesDisplayPlacePageData;
export type IContentAndLuidInfo = IContentInfo & ILuidItem & INamedItem;

/**
 * @deprecated
 * The "raw" node types for the external assets grid are mapped directly in the respective resource queries.
 * For content actions, however, we do further mapping to make the catalog types conform to the VPC IContentInfo interface.
 *
 *  There are three places that graph types need to be mapped to vizportalclient types for content actions:
 * 1. [ListViewGridColumnGenerator.graphActionCellWrapper] - to be passed to catalog so it can map the single item on list view
 * 2. [renderDatabasesActionMenu] and [renderTablesActionMenu] - to be passed to catalog so it can map the single item on place page
 * 3. [ExplorerToolbar] which catalog uses by way of [Explorer] <- [ConnectedExplorer] <- [CatalogBrowserSubspaceExplorer]
 *    somehow we've convinced the explorer that the items being selected in the explorer when on database/tables list are
 *    [IExplorableItemTypeInfo] and it would be preferable to map wherever that is, instead of lying to the type system.
 */
export function mapGraphTypeToContentInfoForActions(content: Tidy<GraphDatabase> | Tidy<GraphTable>): IContentAndLuidInfo | null {

  /**
   * This check for dataQualityIndicators needs to be here since we can get a graph type into an action menu
   * so many different ways we usually end up double mapping and we need to prevent that.
   * I believe I've removed all of the double mapping but am keeping this here in case it's accidentally done again.
   */
  if ((content as any as IContentAndLuidInfo).dataQualityIndicators) {
    return content as any as IContentAndLuidInfo;
  }

  return {
    ...content,
    contentType: ['DatabaseTable', 'DataModel', 'DataLake', 'CalculatedInsight'].indexOf(content.__typename) > -1 ? 'table' : 'database',
    certifier: 'certifier' in content ? mapUser(content.certifier) : undefined,
    contact: 'contact' in content ? mapUser(content.contact) : undefined,
    dataQualityIndicators: [],
    favorite: false,
    updatedAt: new Date(),
    luid: 'luid' in content ? content.luid : '',
    tags: ('tags' in content ? content.tags : []).map((t) => _.isString(t) ? t ?? null : 'name' in t ? t.name : null ?? null).filter((t: unknown) => t),
  };
}

function mapUser(user: TableauUser | null | undefined): IUserInfo | null {
  return user ? {
    id: null,
    username: user.username,
    displayName: user.name,
  } : null;
}
